import MenuItem from '@material-ui/core/MenuItem';
import styled from 'styled-components';

const ThemedSelectMenuItem = styled(MenuItem)`
  color: ${props => props.theme.text};
  background-color: transparent;
  transition: color 120ms ease-in-out, background-color 120ms ease-in-out;

  &:hover {
    color: ${props => props.theme.defaultNavy};
    background-color: ${props => props.theme.blue2};
    box-shadow: inset 4px 0 0 ${props => props.theme.grey};
  }

  &.Mui-selected.MuiMenuItem-root {
    color: ${props => props.theme.selectMenuSelectedText || props.theme.defaultNavy} !important;
    background-color: ${props => props.theme.blue2} !important;
    font-weight: 600;
    box-shadow: inset 4px 0 0 ${props => props.theme.disabledStateBlue} !important;
  }

  &.Mui-selected.MuiMenuItem-root:hover {
    color: ${props => props.theme.selectMenuSelectedText || props.theme.defaultNavy} !important;
    background-color: ${props => props.theme.blue3} !important;
  }
`;

export default ThemedSelectMenuItem;
